import { getQuery } from 'utilities/query';

export default class UserIngredientsService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'UserIngredientName',
      direction: 'asc'
    };
  }

  add(ingredient) {
    return this.$http.post('/api/user_ingredient', ingredient);
  }

  delete(id) {
    return this.$http.delete(`/api/user_ingredient/${id}`);
  }

  update(ingredient) {
    return this.$http.put(`/api/user_ingredient/${ingredient.UserIngredientId}`, ingredient);
  }

  search(query) {
    return this.$http.get('/odata/UserIngredientOData', {
      params: {
        $select: 'UserIngredientId, UserIngredientName, ProductCount',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  isUniqueIngredientName(ingredientName, id) {
    return this.$http.get('/api/user_ingredient/unique_ingredient_name', {
      params: {
        UserIngredientName: ingredientName,
        id
      }
    });
  }
}



// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredients.service.js